export * from './bff-quotes.service';
import { BffQuotesService } from './bff-quotes.service';
export const APIS = [BffQuotesService];
